import React, { useEffect, useState } from "react";
import { mostraAlertaError, mostraAlertaOk, mostraAlertaWarning } from "../../../componentes/alerts/sweetAlert";
import { AxiosPrivado } from "../../../componentes/axios/Axios";
import Card from "../../../componentes/contenedores/Card";
import Page from "../../../componentes/plantilla/Page";
import { ProveedoresGuardar,ProveedoresListar } from "../../../configuracion/apiUrls";
import { regexEmail, regexNombre, regexRTN, regexTelefono } from "../../../configuracion/validaciones";
import { useContextEmpleado } from "../../../contexto/empleado/EmpleadoContext";

const HomeProveedores = () => {
    const { setListaProveedores, ActualizarLista } = useContextEmpleado();
    const [formularioProveedores, setFormularioProveedores] = useState({
        id: null,
        nombre: "",
        correo: "",
        rtn: "",
        telefonos: [{ telefono: "", contacto: "" }],
    });
    const [errorRtn, setErrorRtn] = useState(false);
    const [errorNombre, setErrorNombre] = useState(false);
    const [errorCorreo, setErrorCorreo] = useState(false);
    const [errorTelefonos, setErrorTelefonos] = useState([]);

    useEffect(() => {
        setErrorNombre(!regexNombre.test(formularioProveedores.nombre));
        setErrorCorreo(!regexEmail.test(formularioProveedores.correo));

        if (formularioProveedores.rtn) {
            setErrorRtn(!regexRTN.test(formularioProveedores.rtn));
        } else {
            setErrorRtn(false);
        }

        const nuevosErrores = formularioProveedores.telefonos.map((numero) => {
            const tieneTelefono = numero.telefono.length > 0;
            const tieneContacto = numero.contacto.length > 0;

            const errorTelefono = tieneTelefono && (
                !regexTelefono.test(numero.telefono) || numero.telefono.length !== 8
            );

            const errorContacto = tieneContacto && numero.contacto.length < 3;

            return {
                telefono: errorTelefono,
                contacto: errorContacto
            };
        });
        setErrorTelefonos(nuevosErrores);
    }, [formularioProveedores]);

    const manejadorProveedores = (event) => {
        setFormularioProveedores({
            ...formularioProveedores,
            [event.target.name]: event.target.value,
        });
    };

    const manejarCambioNumeros = (index, field, value) => {
        const nuevosNumeros = [...formularioProveedores.telefonos];
        nuevosNumeros[index][field] = value;

        setFormularioProveedores({
            ...formularioProveedores,
            telefonos: nuevosNumeros,
        });
    };

    const agregarNumero = () => {
        setFormularioProveedores((prevState) => ({
            ...prevState,
            telefonos: [...prevState.telefonos, { telefono: "", contacto: "" }],
        }));
    };

    const eliminarNumero = (index) => {
        setFormularioProveedores((prevState) => {
            const nuevosNumeros = [...prevState.telefonos];
            nuevosNumeros.splice(index, 1);

            if (nuevosNumeros.length === 0) {
                return { ...prevState, telefonos: [{ telefono: "", contacto: "" }] };
            }
            return { ...prevState, telefonos: nuevosNumeros };
        });
    };

    const quitarCamposVacios = (obj) => {
        const nuevosDatos = Object.keys(obj).reduce((acc, key) => {
            if (key === 'telefonos') {
                acc[key] = obj[key].filter(
                    (t) => (t.telefono !== "" && t.telefono !== null && t.telefono !== undefined) ||
                        (t.contacto !== "" && t.contacto !== null && t.contacto !== undefined)
                );
                if (acc[key].length === 0) {
                    delete acc[key];
                }
            } else if (obj[key] !== "" && obj[key] !== null && obj[key] !== undefined) {
                acc[key] = obj[key];
            }
            return acc;
        }, {});
        return nuevosDatos;
    };

    const guardarProveedor = async () => {
        const erroresDeFormatoGeneral = errorRtn || errorNombre || errorCorreo;

        const erroresDeTelefonoOContacto = errorTelefonos.some(err =>
            err.telefono || err.contacto
        );

        const nombreVacio = formularioProveedores.nombre === "";

        if (erroresDeFormatoGeneral || erroresDeTelefonoOContacto || nombreVacio) {
            mostraAlertaWarning("Existen errores o campos obligatorios incompletos. Por favor, revise los campos marcados.");
            return;
        }

        try {
            const nuevosDatos = quitarCamposVacios(formularioProveedores);

            await AxiosPrivado.post(ProveedoresGuardar, nuevosDatos)
                .then(async (respuesta) => {
                    mostraAlertaOk("Proveedor guardado correctamente");
                    ActualizarLista(ProveedoresListar, setListaProveedores);
                    limpiarDatos();
                })
                .catch((er) => {
                    const { response } = er;
                    if (response?.data && Array.isArray(response.data)) {
                        const mensajesError = response.data.map(error => error.msg).join(', ');
                        mostraAlertaError(mensajesError, "error");
                    } else if (response?.data?.msj || response?.data?.error?.message) {
                        const msjError = response?.data?.msj || response?.data?.error?.message;
                        mostraAlertaError(msjError, "error");
                    } else {
                        mostraAlertaError("Error de comunicación con el servidor", "error");
                    }
                });
        } catch (error) {
            console.error(error);
            mostraAlertaError("Error al guardar el proveedor");
        }
    };

    const limpiarDatos = () => {
        setFormularioProveedores({
            id: null,
            nombre: "",
            correo: "",
            rtn: "",
            telefonos: [{ telefono: "", contacto: "" }],
        });
        setErrorRtn(false);
        setErrorCorreo(false);
        setErrorNombre(false);
        setErrorTelefonos([]);
    };

    const datos = {
        titulo: {
            titulo: formularioProveedores.id ? "Editar proveedor" : "Nuevo proveedor",
            url: "/app/admin/proveedores/nuevo",
            tituloUrl: "Menu Proveedores",
            nombreUrl: "Inicio ",
        },
    };

    const BotonGuardar = () => {
        return (
            <>
                <button
                    type="button"
                    className="btn btn-success mr-3"
                    onClick={guardarProveedor}
                >
                    Guardar
                </button>
                <button
                    type="button"
                    className="btn btn-warning mr-3"
                    onClick={limpiarDatos}
                >
                    Limpiar
                </button>
            </>
        );
    };

    return (
        <Page datos={datos}>
            <Card titulo="Datos del proveedor"
                pie={<BotonGuardar />}>
                <div className="row">
                    <div className="col-sm-12 col-lg-12">
                        <div className="row">
                            <div className="col-lg-6 col-sm-12">
                                <div className="form-group">
                                    <label htmlFor="rtn-proveedor">RTN</label>
                                    <input
                                        id="rtn-proveedor"
                                        type="text"
                                        className={`form-control ${errorRtn ? "is-invalid" : ""}`}
                                        placeholder="RTN"
                                        name="rtn"
                                        value={formularioProveedores.rtn}
                                        onChange={manejadorProveedores}
                                    />
                                    {errorRtn && (
                                        <div className="invalid-feedback">
                                            El RTN debe tener exactamente 14 dígitos.
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="col-lg-6 col-sm-12">
                                <div className="form-group">
                                    <label htmlFor="nombre-proveedor">Nombre del proveedor (*)</label>
                                    <input
                                        id="nombre-proveedor"
                                        type="text"
                                        className={`form-control ${errorNombre ? "is-invalid" : ""}`}
                                        placeholder="Nombre del proveedor"
                                        name="nombre"
                                        value={formularioProveedores.nombre}
                                        onChange={manejadorProveedores}
                                    />
                                    {errorNombre && (
                                        <div className="invalid-feedback">
                                            El nombre de proveedor debe tener al menos 3 caracteres.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-6 col-sm-12">
                                <div className="form-group">
                                    <label htmlFor="correo-proveedor">Correo electrónico</label>
                                    <input
                                        id="correo-proveedor"
                                        type="email"
                                        className={`form-control ${errorCorreo ? "is-invalid" : ""}`}
                                        placeholder="Correo electrónico"
                                        name="correo"
                                        value={formularioProveedores.correo}
                                        onChange={manejadorProveedores}
                                    />
                                    {errorCorreo && (
                                        <div className="invalid-feedback">
                                            Correo electrónico inválido
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <h5 className="mt-4">Teléfonos de contacto</h5>
                        <hr />
                        <div className="row mb-3">
                            <div className="col-sm-3">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={agregarNumero}
                                >
                                    <i className="fa fa-plus" aria-hidden="true"></i> Agregar teléfono
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            {formularioProveedores.telefonos.map((numero, index) => {
                                const erroresTelefono = errorTelefonos[index] || {};
                                const errorNumero = erroresTelefono.telefono;
                                const errorContacto = erroresTelefono.contacto;

                                return (
                                    <div key={index} className="col-md-12 mb-3">
                                        <div className="row">
                                            <div className="col-md-5">
                                                <label htmlFor={`telefono-${index}`}>Número de teléfono</label>
                                                <input
                                                    id={`telefono-${index}`}
                                                    type="text"
                                                    className={`form-control ${errorNumero ? "is-invalid" : ""}`}
                                                    placeholder="Ej: 88887777 (8 dígitos)"
                                                    name="telefono"
                                                    value={numero.telefono}
                                                    onChange={(event) =>
                                                        manejarCambioNumeros(index, "telefono", event.target.value)
                                                    }
                                                />
                                                {errorNumero && (
                                                    <div className="invalid-feedback">
                                                        Número inválido. Debe contener exactamente 8 dígitos.
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-md-5">
                                                <label htmlFor={`contacto-${index}`}>Nombre de contacto</label>
                                                <input
                                                    id={`contacto-${index}`}
                                                    type="text"
                                                    className={`form-control ${errorContacto ? "is-invalid" : ""}`}
                                                    placeholder="Ej: Nombre de contacto"
                                                    name="contacto"
                                                    value={numero.contacto}
                                                    onChange={(event) =>
                                                        manejarCambioNumeros(index, "contacto", event.target.value)
                                                    }
                                                />
                                                {errorContacto && (
                                                    <div className="invalid-feedback">
                                                        El nombre de contacto debe tener al menos 3 caracteres.
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-md-2 d-flex align-items-end">
                                                {formularioProveedores.telefonos.length > 1 && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger"
                                                        onClick={() => eliminarNumero(index)}
                                                    >
                                                        <i className="fa fa-minus" aria-hidden="true"></i>
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </Card>
        </Page>
    );
}

export default HomeProveedores;